import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKanbanView: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"kanban-view, columns"} maskId="square-filled-radius-0-stroke-1-IconKanbanView"><path d="M2 4V16H8V4H2Z" fill="currentColor"/><path d="M9 4V20H15V4H9Z" fill="currentColor"/><path d="M16 4V14H22V4H16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconKanbanView;
